import { render } from "./Additional-prods.vue?vue&type=template&id=76677f2a&scoped=true"
import script from "./Additional-prods.vue?vue&type=script&lang=js"
export * from "./Additional-prods.vue?vue&type=script&lang=js"

import "./Additional-prods.vue?vue&type=style&index=0&id=76677f2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76677f2a"]])

export default __exports__